// import data from "../../shared/sharedData";
export default {
  name: "Additional  Worksites",
  pageInfo: {
    text: "This Addendum must be fully completed and submitted with the Form ETA-9141C when the employer needs to disclose other worksites.",
    coloring: "grey",
    // read_more: true,
    // character_limit: 925,
    isVisible: {
      when: "otherWorksiteLocation",
      is: "YES",
    },
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field E.c.6 whether or not there will be other worksites.",
        type: "info",
        isVisible: {
          when: "otherWorksiteLocation",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description:
          "Because you indicated that there are no other worksites, no Addendum A is necessary for this application.",
        type: "success",
        isVisible: {
          when: "otherWorksiteLocation",
          is: "NO",
        },
      },
    ],
  },
  sections: [
    {
      code: "Addendum A",
      machine_name: "otherWorksites",
      name: "Additional Worksites",
      sectionHeader: "Record(s)",
      isVisible: {
        when: "otherWorksiteLocation",
        is: "YES",
      },
      isModal: true,
      openModalHeader: "Add Addendum A",
      modalHeader: "Add Worksite",
      validate: ["tableRequired", "tableIncomplete"],
      label:
        "Use the table below to enter the details about each worksite, when applicable.",
      listType: "table",
      maxLength: 250,
      removeFromFieldArray: true,
      modalFields: [
        // {
        //   hideOnTable: true,
        //   machine_name: "worksiteAddr1",
        //   label: "Address 1",
        //   widget: "text",
        //   maxLength: 30,
        //   validate: ["required"],
        // },
        // {
        //   hideOnTable: true,
        //   machine_name: "worksiteAddr2",
        //   label: "Address 2",
        //   widget: "text",
        //   maxLength: 30,
        // },
        {
          machine_name: "worksiteCity",
          label: "City",
          widget: "text",
          maxLength: 20,
          validate: ["required"],
        },
        {
          hideOnTable: true,
          machine_name: "worksiteState",
          label: "State",
          widget: "select",
          // placeholder: ["NORTHERN MARIANA ISLANDS"],
          selection: ["NORTHERN MARIANA ISLANDS"],
          validate: ["required"],
          // disabled: true,
        },
        {
          hideOnTable: true,
          machine_name: "worksiteCountyTownship",
          label: "County",
          widget: "countyselect",
          parent_machine_name: "add_values_field",
          disableWhenField: "worksiteState",
          validate: ["required"],
        },
        {
          machine_name: "worksitePostalCode",
          label: "Postal Code",
          widget: "text",
          maxLength: 20,
          validate: [
            "required",
            "postalUSA",
            { postalCompare: ["96950", "96951", "96952"] },
          ],
        },
        // {
        //   hideOnTable: true,
        //   machine_name: "worksiteBlsAreaId",
        //   label: "Bls Area Id",
        //   widget: "text",
        //   maxLength: 20,
        //   validate: ["required"],
        // },
      ],
    },
  ],
};
